import React from "react";
import gql from "graphql-tag";
import { Mutation } from '@apollo/client/react/components';

import { MIN_PASSWORD_LENGTH } from "../constants";
import { withRouter } from "react-router";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";

import LoadingView from "./LoadingView";
import ErrorView from "./ErrorView";

import KVALogoWide from "./KVALogoWide";
import OpenSource from "./OpenSource";

import "../styles/Login.css";

const SET_PASSWORD = gql`
  mutation SetPassword($token: String!, $password: String!) {
    setPassword(token: $token, password: $password) {
      isError
      message
    }
  }
`;

interface INewPasswordProps {
  match: any;
  history: any;
  location: any;
}

class NewPassword extends React.Component<INewPasswordProps> {
  state: {
    token?: string;
    password: string;
    passwordConfirmation: string;

    result?: {
      isError: boolean;
      message: string;
    };
  };

  constructor(props: INewPasswordProps) {
    super(props);

    this.state = {
      token: props.match.params.token,
      password: "",
      passwordConfirmation: "",
      result: undefined,
    };

    this.handleConfirmation = this.handleConfirmation.bind(this);
    this.handlePassword = this.handlePassword.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  validateForm() {
    return (
      this.state.password.length >= MIN_PASSWORD_LENGTH &&
      this.state.password === this.state.passwordConfirmation
    );
  }

  passwordErrorMsg() {
    if (
      this.state.password.length > 0 &&
      this.state.password.length < MIN_PASSWORD_LENGTH
    ) {
      return `Passwort ist zu kurz. Mindestlänge sind ${MIN_PASSWORD_LENGTH} Zeichen.`;
    }

    if (
      this.state.password.length > 0 &&
      this.state.passwordConfirmation.length > 0 &&
      this.state.password !== this.state.passwordConfirmation
    ) {
      return "Passwörter stimmen nicht überein.";
    }

    return "";
  }

  handlePassword(event: any) {
    this.setState({ ...this.state, password: event.target.value });
  }

  handleConfirmation(event: any) {
    this.setState({ ...this.state, passwordConfirmation: event.target.value });
  }

  handleSubmit(event: any, set_password: any) {
    event.preventDefault();
    set_password({
      variables: { token: this.state.token, password: this.state.password },
    });
  }

  resultModal() {
    if (!this.state.result) {
      return <></>;
    }

    const variant = this.state.result.isError === true ? "danger" : "success";

    return <Alert variant={variant}>{this.state.result.message}</Alert>;
  }

  render() {
    if (!this.state.token || this.state.token.length < 10) {
      return (
        <>
          <div id="big-wrapper">
            <Container fluid>
              <div className="depth1">
                <Row>
                  <Col xs={12} md={4} lg={3} className="fully bg-blue" />
                  <Col xs={12} md={8} lg={9} className="bg-img" />
                </Row>
              </div>
              <div className="depth2">
                <Container fluid>
                  <Row>
                    <Col xs={2} md={6} lg={6} />
                    <Col xs={10} md={6} lg={6}>
                      <div className="p-4">
                        <KVALogoWide />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      xs={12}
                      md={{ span: 6, offset: 3 }}
                      lg={{ span: 4, offset: 2 }}
                    >
                      <div className="form-wrapper brt-3 brb-3">
                        <h2 className="p4">
                          Kein Token angegeben.
                          <br />
                          Bitte überprüfen Sie, ob die Adresse vollständig ist.
                        </h2>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </div>
            </Container>
          </div>
        </>
      );
    }

    return (
      <Mutation
        mutation={SET_PASSWORD}
        onCompleted={(data: any) =>
          this.setState({ ...this.state, result: data["setPassword"] })
        }
      >
        {(set_password: any, { loading, error, data }: any) => {
          if (loading) {
            return <LoadingView />;
          }

          if (error) {
            if (error.networkError != null) {
              return <ErrorView error={error} />;
            }
          }

          return (
            <>
              <div id="big-wrapper">
                <Container fluid>
                  <div className="depth1">
                    <Row>
                      <Col xs={12} md={4} lg={3} className="fully bg-blue" />
                      <Col xs={12} md={8} lg={9} className="bg-img" />
                    </Row>
                  </div>
                  <div className="depth2">
                    <Container fluid>
                      <Row>
                        <Col xs={2} md={6} lg={6} />
                        <Col xs={10} md={6} lg={6}>
                          <div className="p-4">
                            <KVALogoWide />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          xs={12}
                          md={{ span: 6, offset: 3 }}
                          lg={{ span: 4, offset: 2 }}
                        >
                          <div className="form-wrapper brt-3 brb-3">
                            <h2 className="underline">Passwort zurücksetzen</h2>
                            {this.state.result === undefined && (
                              <form
                                className="reset_password"
                                id="reset_password"
                                acceptCharset="UTF-8"
                                onSubmit={(event) =>
                                  this.handleSubmit(event, set_password)
                                }
                              >
                                <div className="form-group">
                                  <div className="form-group password required account_password">
                                    <label
                                      className="control-label password required"
                                      htmlFor="account_password"
                                    >
                                      Passwort
                                    </label>
                                    <input
                                      className="form-control string password required form-control"
                                      value={this.state.password}
                                      placeholder="Ihr neues Passwort"
                                      type="password"
                                      onChange={this.handlePassword}
                                    />
                                  </div>
                                  <div className="form-group password required account_password_confirmation">
                                    <label
                                      className="control-label password_confirmation required"
                                      htmlFor="account_password"
                                    >
                                      Passwort bestätigen
                                    </label>
                                    <input
                                      className="form-control string password required form-control"
                                      value={this.state.passwordConfirmation}
                                      placeholder="Bitte Passwort bestätigen"
                                      type="password"
                                      onChange={this.handleConfirmation}
                                    />
                                  </div>
                                </div>

                                <div style={{ padding: 10, color: "red" }}>
                                  {this.passwordErrorMsg()}
                                </div>

                                <Row>
                                  <Col>
                                    <input
                                      type="submit"
                                      className="btn btn-primary"
                                      name="commit"
                                      value="Passwort speichern!"
                                      disabled={!this.validateForm()}
                                    />
                                  </Col>
                                </Row>
                              </form>
                            )}
                            {this.resultModal()}
                            {this.state.result !== undefined && (
                              <Container fluid>
                                <Row>
                                  <Col>
                                    <Button
                                      onClick={() =>
                                        this.props.history.replace("/login")
                                      }
                                    >
                                      Zurück zum Login
                                    </Button>
                                  </Col>
                                </Row>
                              </Container>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                </Container>
              </div>
              <OpenSource extern={true} />
            </>
          );
        }}
      </Mutation>
    );
  }
}

export default withRouter(NewPassword);
